import { render, staticRenderFns } from "./FormSupplier.vue?vue&type=template&id=2fe46477"
import script from "./FormSupplier.vue?vue&type=script&lang=js"
export * from "./FormSupplier.vue?vue&type=script&lang=js"
import style0 from "./FormSupplier.vue?vue&type=style&index=0&id=2fe46477&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports